<template>
  <div
    :class="{['text-' + align]: true, [padding]: !!padding}"
  >
    <div
      v-if="!withoutIcon"
      class="text-h2"
    >
      <q-icon
        :name="icon"
        :color="iconColor"
      />
    </div>
    <q-item-label
      class="text-bold text-body1"
      :class="{'q-pt-md': !withoutIcon}"
    >
      {{ title }}
    </q-item-label>
    <q-item-label v-if="subtitle" class="q-pt-xs">
      {{ subtitle }}
    </q-item-label>
    <div
      v-if="hasDefaultSlot"
      class="q-pt-xs"
    >
      <slot />
    </div>
  </div>
</template>

<script>
/**
 * Display content if no results for content are found
 *
 * SLOTS:
 * - default: additional content to display
 */
export default {
  props: {
    // Title to display
    title: {
      type: String,
      default: 'No results to display'
    },
    // Subtitle to display
    subtitle: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: 'mdi-alert-circle-outline'
    },
    iconColor: {
      type: String
    },
    // Disable showing the icon
    withoutIcon: {
      type: Boolean,
      default: false
    },
    // Alignment of content (left, center, right)
    align: {
      type: String,
      default: 'center'
    },
    // Add padding to element
    padding: {
      type: String,
      default: 'q-px-md q-py-sm'
    }
  },
  computed: {
    hasDefaultSlot () {
      return !!this.$slots.default
    }
  }
}
</script>
